import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setDropModalOpen } from 'redux/actions';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { IconLoader } from 'common/IconLoader';
import SvgAF from '../SvgAF/SvgAF';

import './DropModal.css';

class DropModal extends Component {
  state = {
    isControlled: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    // this.props.dispatch(setDropModalOpen(this.props.name, false));
  }

  componentDidUpdate() {
    if (this.props.forceClose && this.props.dropModals[this.props.name] === true && !this.state.isControlled) {
      this.props.dispatch(setDropModalOpen(this.props.name, false));
      this.setState({ isControlled: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick = (e) => {
    /* When drop modals get clicked, reset the tooltip */
    ReactTooltip.hide();
    ReactTooltip.rebuild();

    let isOpen = this.props.dropModals[this.props.name] === true;

    if (!this.node.contains(e.target)) {
      if (isOpen) {
        this.props.dispatch(setDropModalOpen(this.props.name, false));
        this.props.isOpenListener && this.props.isOpenListener(false);
      }
    }
  };

  toggleMenu = () => {
    if (this.props.onClick) this.props.onClick();
    let toOpen = !(this.props.dropModals[this.props.name] === true);
    this.props.dispatch(setDropModalOpen(this.props.name, toOpen));

    if (toOpen) {
      this.props.isOpenListener && this.props.isOpenListener(true);
      if (this.state.isControlled) this.setState({ isControlled: false });
    }
  };

  handleClose = () => {
    this.props.dispatch(setDropModalOpen(this.props.name, false));
  };

  getTrimmedFilters = (key, activeFilters) => {
    if (key === 'Provisioned On') return activeFilters;
    const MAX_ACTIVE_FILTER_LENGTH = 30;
    const filterString = activeFilters.join(', ');
    if (filterString.length <= MAX_ACTIVE_FILTER_LENGTH) return filterString;

    return filterString.substring(0, MAX_ACTIVE_FILTER_LENGTH - 3) + '...';
  };

  render() {
    let isOpen = this.props.dropModals[this.props.name] === true;

    let style = {};
    if (this.props.height) {
      style.height = this.props.height;
    }
    if (this.props.maxHeight) {
      style.maxHeight = this.props.maxHeight;
    }
    if (this.props.width) {
      style.height = this.props.width;
    }

    return (
      <div className={this.props.className} style={{ display: 'flex' }}>
        {this.props.activeFilterItems && (
          <div className={'filterBoxContainer'} ref={(node) => (this.node = node)}>
            <button
              data-testid={this.props['data-testid']}
              aria-label={this.props['aria-label']}
              className={classnames('dropModalButton', 'activeFilter')}
              onClick={this.toggleMenu}
            >
              <div className="activeFilterTitle">{this.props.title}</div>
              <div className="activeFilterItems">
                {this.getTrimmedFilters(this.props.title, this.props.activeFilterItems)}
              </div>
            </button>
            <button className={'filterBoxCloseX'} onClick={() => this.props.onClose(this.props.title)}>
              <SvgAF img={IconLoader.icon_clear_flter_x} hover={IconLoader.icon_clear_flter_x_hover} />
            </button>

            <div
              style={{ height: this.props.height, width: this.props.width, maxHeight: this.props.maxHeight }}
              className={classnames(
                'modal dropModalContent ',
                { shown: isOpen },
                { hidden: !isOpen }
                // { alarmsHistoryDropModalContent: this.props.alarmsHistory }
              )}
            >
              {this.props.children}
            </div>
          </div>
        )}
        {!this.props.activeFilterItems && (
          <div
            className={classnames({
              dropModalContainer: !this.props.isFilterBox,
              filterBoxContainer: this.props.isFilterBox
            })}
            ref={(node) => (this.node = node)}
          >
            <button
              data-testid={this.props['data-testid']}
              aria-label={this.props['aria-label']}
              className={classnames('dropModalButton', {
                pickedFilter: this.props.isActive,
                inactiveFilter: this.props.isFilterBox,
                clearDropModalButton: this.props.colorMode === 'clear'
              })}
              onClick={this.toggleMenu}
            >
              {this.props.title}
              {this.props.showArrow && (
                <img
                  className={classnames('ddArrowRight', { iconTurn: isOpen })}
                  src={IconLoader.icon_dropdown_arrow}
                  alt={''}
                />
              )}
            </button>
            <div
              style={{ height: this.props.height, width: this.props.width, maxHeight: this.props.maxHeight }}
              className={classnames(
                'dropModalContent',
                { modal: !this.props.alarmsHistory },
                { shown: isOpen && !this.props.alarmsHistory },
                { hidden: !isOpen },
                { alarmsHistoryDropModalContent: this.props.alarmsHistory }
              )}
            >
              {this.props.children}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect((store) => {
  return {
    dropModals: store.ui.sharedPages.dropModals
  };
})(DropModal);
